import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { CHATS_COLLECTION, CHATS_MESSAGES_COLLECTION } from "../../constants";
import db from "../../firebaseConfig";
import LoadingIndicator from "../layouts/LoadingIndicator";
import * as moment from 'moment';
import { useHistory } from "react-router-dom";


const ChatRoom = ({ auth }) => {

    const location = useLocation();
    // console.log(location)
    const {user} = location.state;
    const [messages, setMessages] = useState([]);
    const [message, setMessage] = useState('');
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const history = useHistory();

    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
    }
    
    useEffect(() => {
        // const controller = new AbortController();
        // controller.abort();
        if(messages.length === 0) {
            return getMessages();
        }
    }, []);

    const getMessages = async () => {
        setLoading(true);
        setError('');
        let doc = await db.collection(CHATS_COLLECTION)
        .doc(user.uid)
        .get();
        // console.log(isNew);
        if (!doc.exists) {
            // console.log('No such document exista!');
            await db.collection(CHATS_COLLECTION)
                .doc(user.uid)
                .set({
                    'displayName': user.displayName,
                    'email': user.email,
                    'photoURL': user.photoURL,
                    'status': false,
                    'createdAt': new Date(),
                    'updatedAt': new Date(),
                });
        } else {
            // console.log('Document data:', doc.data());
            await db.collection(CHATS_COLLECTION)
            .doc(user.uid)
            .collection(CHATS_MESSAGES_COLLECTION)
            .orderBy("createdAt", "asc")
            .limit(25)
            .get()
            .then((querySnapshot) => {
                var data = [];
                querySnapshot.forEach((doc) => {
                    // doc.data() is never undefined for query doc snapshots
                    // let d = doc.collection('messages').get().then(querySnapshot => querySnapshot.size);
                    // console.log('d')
                    // console.log(doc.id, " => ", doc.collection('messages').get().then(querySnapshot => querySnapshot.size));
                    data.push({
                        uid: doc?.id,
                        content: doc.data()?.content,
                        from: doc.data()?.from,
                        unread: doc.data()?.unread,
                        createdAt: moment(doc.data()?.createdAt.toDate().toString()).fromNow(),
                        // createdAt: doc.data()?.createdAt.toDate().toLocaleTimeString('en-US'),
                        updatedAt: doc.data()?.updatedAt
                    });
                });
                
                setMessages(data);
                // console.log(data)
                // setDiamonds(data);
            })
            .catch((error) => {
                // console.log("Error getting documents: ", error);
                setError(error.message);
            });
            
            await db.collection(CHATS_COLLECTION).doc(user.uid).update({status: false});
        }


        setLoading(false);
        
        scrollToBottom();
    }

    const handleSubmit = async () => {
        setError('');
        if(message !== '') {
            let messageData = {
                'content': message,
                'from': 'admin',
                // 'from': auth.user.type,
                'unread': true,
                'createdAt': new Date(),
                'updatedAt': new Date(),
            };
            const uid = await db.collection(CHATS_COLLECTION)
                .doc(user.uid)
                .collection(CHATS_MESSAGES_COLLECTION)
                .add(messageData).then((docRef) => docRef.id);
            // .catch((error) => {
            //     // console.error("Error adding document: ", error);
            // });
            messageData.uid = uid;
            messageData.createdAt = moment(messageData.createdAt.toString()).fromNow()
            setMessages([...messages, messageData]);
            // getMessages();
            // console.log(uid)
            setMessage('');
            scrollToBottom();
        } else {
            setError('Empty message can not be send.');
        }
    }

    const showMessagesCards = () => {
        return messages.map((message, index) => {
            if(message.from === 'user') {
                return (
                    <div key={index} className="flex justify-start">
                        <div className="bg-blue-200 backdrop-filter backdrop-blur-lg bg-opacity-50 overflow-hidden shadow w-3/4 mx-4 my-2 p-4 rounded-lg" >
                            <div className="">{message.content}</div>
                            <div className="mt-2 text-xs text-gray-700">{message.createdAt}</div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div key={index} className="flex justify-end">
                        <div className="bg-blue-400 backdrop-filter backdrop-blur-lg bg-opacity-50 overflow-hidden shadow w-3/4 mx-4 my-2 p-4 rounded-lg clearfix"
                        >
                            <div className="">{message.content}</div>
                            <div className="mt-2 text-xs text-gray-700">{message.createdAt}</div>
                        </div>
                    </div>
                );
            }
        });
    }

    // console.log(user)
    return ( <>
        <div>
            <div className="fixed z-50 w-full bg-blue-400 h-16 py-2 px-4 text-white flex justify-between items-center top-0 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow">
                <button onClick={() => history.goBack()} className=" text-gray-200">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
                    </svg>
                </button>
                <div className="text-green-100 tracking-wide text-2xl">{user.displayName}</div>
                <img className="w-10 h-10 object-cover rounded-full border-2 border-bg-gray-300" src={user.photoURL} alt="" />
                {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="icon-dots-vertical w-8 h-8 mt-2 mr-2"
                >
                    <path
                    className="text-green-100 fill-current"
                    fill-rule="evenodd"
                    d="M12 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
                    />
                </svg> */}
            </div>

            <div className="mt-20 mb-16">
                {loading ? (<LoadingIndicator/>) : messages && showMessagesCards()}
                
                <div ref={messagesEndRef} />
            </div>
        </div>

        <div className="fixed w-full flex justify-between bg-blue-400 bottom-0 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow">
            <textarea
                className="flex-grow m-2 py-2 px-4 mr-1 rounded-full border border-gray-300 bg-gray-900 text-white resize-none outline-none backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden"
                rows="1"
                placeholder="Type..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
            ></textarea>
            <button className="m-2 outline-none" onClick={() => handleSubmit()} >
                <svg
                    className="svg-inline--fa text-blue-400 fa-paper-plane fa-w-16 w-12 h-12 py-2 mr-2"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="paper-plane"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                >
                    <path
                    fill="currentColor"
                    d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
                    />
                </svg>
            </button>
        </div>
    </> );
}

const mapStateToProps = state => {
    return {
        auth: state.auth
    };
}


// const mapDispatchToProps = dispatch => {
//     return {
//         updateMessengerProfiles: (latestData) => dispatch(updateMessengerProfiles(latestData)),
//         updateMessengerProfilesCollections: (collections) => dispatch(updateMessengerProfilesCollections(collections))
//     }
// }

export default connect(mapStateToProps)(ChatRoom);